import axios from "axios";
import AppSettings from "../appsettings";

const BASE_URL = `${AppSettings.API_BASE_URL}/paymentMethods/admin`;

const adminPaymentService = {
  getAllPublishersWithPayments: async () => {
    const res = await axios.get(`${BASE_URL}/get-all-publishers-with-payments`);
    return res.data;
  },

  toggleVerification: async (paymentMethodId) => {
    const res = await axios.patch(`${BASE_URL}/verify-payment-method/${paymentMethodId}`);
    return res.data;
  },
};

export default adminPaymentService;
